// The admin section's pages, in menu order. The Navbar's Admin dropdown and
// the routes in App.jsx both read this list.
export const ADMIN_PAGES = [
  { display: 'Demo outreach', url: '/admin/demo' },
  { display: 'Users', url: '/admin/users', kind: 'users' },
  { display: 'Sets', url: '/admin/sets', kind: 'sets' },
  { display: 'Tracks', url: '/admin/tracks', kind: 'tracks' },
  { display: 'Artists', url: '/admin/artists', kind: 'artists' },
  { display: 'Share links', url: '/admin/shares', kind: 'shares' },
];
